import { jsx as _jsx } from "react/jsx-runtime";
import { FavoritesList } from '../features/favorites';
export const Favorites = () => {
  return /*#__PURE__*/_jsx(FavoritesList, {});
};
export default Favorites;